import { CompanyConstant } from '../actions/constants/CompanyConstant';
// IMP-376: 회사 목록 이름순 정렬 comparator (SSoT)
const byName = (a, b) => (a?.name || '').localeCompare(b?.name || '');
const initialState =
{
    companies : [],
    company : {},
    filter : {},
	isUpdateRes: false,
};
export const CompanyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CompanyConstant.ADD_COMPANYINFO:
            // IMP-376: 회사 목록 이름순 정렬 불변식
            return {...state,
                companies : [...state.companies, action.company].sort(byName),
                company : action.company,
                isUpdateRes : true};
        case CompanyConstant.UPDATE_COMPANYINFO:
            // IMP-376: 회사 목록 이름순 정렬 불변식
            return {...state,
                companies : state.companies.map(u => u._id == action.company._id ? action.company : u).sort(byName),
                company : action.company,
                isUpdateRes : true
            };
        case CompanyConstant.DELETE_COMPANY:
            // BUG-176: DeleteCompany 는 delcompanyid=companyId 를 디스패치하는데 기존 필터가 _id 만
            // 비교해 삭제된 회사가 목록에 잔존. companyId/_id 어느 식별자로 와도 제거되도록 보정.
            return {...state,
                companies : state.companies.filter(u => u.companyId !== action.delcompanyid && u._id !== action.delcompanyid),
                isUpdateRes : true
            };
        case CompanyConstant.CLEAR_UPDATERES:
            return { ...state, isUpdateRes : false };
        case CompanyConstant.GET_COMPANYLIST:
            // IMP-376: 회사 목록 이름순 정렬 불변식
            return {...state, companies : [...(action.companies || [])].sort(byName), isUpdateRes : false };
        case CompanyConstant.GET_COMPANY:
            // IMP-376: 회사 목록 이름순 정렬 불변식
            return {...state,
                companies : state?.companies && state?.companies?.length > 0 ? state.companies.map(u => u._id == action?.company?._id ? action?.company : u).sort(byName) : [],
                company : action?.company || {},
                isUpdateRes : false};
        default:
            return state
    }
}
